import { IconProps } from './icons-props';

function MonitorIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.56 17.97H6.44C2.46 17.97 1.25 16.76 1.25 12.78V6.44C1.25 2.46 2.46 1.25 6.44 1.25H8C8.41 1.25 8.75 1.59 8.75 2C8.75 2.41 8.41 2.75 8 2.75H6.44C3.3 2.75 2.75 3.3 2.75 6.44V12.77C2.75 15.91 3.3 16.46 6.44 16.46H17.55C20.69 16.46 21.24 15.91 21.24 12.77V11.88C21.24 11.47 21.58 11.13 21.99 11.13C22.4 11.13 22.74 11.47 22.74 11.88V12.77C22.75 16.76 21.54 17.97 17.56 17.97Z'
                fill='currentColor'
            />
            <path
                d='M12 22.7502C11.59 22.7502 11.25 22.4102 11.25 22.0002V17.2202C11.25 16.8102 11.59 16.4702 12 16.4702C12.41 16.4702 12.75 16.8102 12.75 17.2202V22.0002C12.75 22.4102 12.41 22.7502 12 22.7502Z'
                fill='currentColor'
            />
            <path
                d='M22 13.75H2C1.59 13.75 1.25 13.41 1.25 13C1.25 12.59 1.59 12.25 2 12.25H22C22.41 12.25 22.75 12.59 22.75 13C22.75 13.41 22.41 13.75 22 13.75Z'
                fill='currentColor'
            />
            <path
                d='M16.5 22.75H7.5C7.09 22.75 6.75 22.41 6.75 22C6.75 21.59 7.09 21.25 7.5 21.25H16.5C16.91 21.25 17.25 21.59 17.25 22C17.25 22.41 16.91 22.75 16.5 22.75Z'
                fill='currentColor'
            />
            <path
                d='M17.86 10.1198H13.1C11.53 10.1198 10.51 9.09977 10.51 7.52977V4.00977C10.51 2.48977 11.74 1.25977 13.26 1.25977H17.86C19.29 1.25977 20.45 2.41977 20.45 3.84977V7.52977C20.45 8.95977 19.29 10.1198 17.86 10.1198ZM13.26 2.75977C12.57 2.75977 12.01 3.31977 12.01 4.00977V7.52977C12.01 8.50977 12.63 8.61977 13.1 8.61977H17.86C18.46 8.61977 18.95 8.12977 18.95 7.52977V3.84977C18.95 3.24977 18.46 2.75977 17.86 2.75977H13.26Z'
                fill='currentColor'
            />
            <path
                d='M21.45 8.87019C21.13 8.87019 20.7999 8.76019 20.4799 8.53019L19.27 7.68019C19.07 7.54019 18.95 7.31019 18.95 7.07019V4.31019C18.95 4.07019 19.07 3.84019 19.27 3.70019L20.4799 2.85019C20.9999 2.48019 21.56 2.41019 22.02 2.65019C22.48 2.89019 22.74 3.39019 22.74 4.03019V7.36019C22.74 8.00019 22.48 8.50019 22.02 8.74019C21.85 8.83019 21.66 8.87019 21.45 8.87019ZM20.45 6.68019L21.25 7.24019V4.14019L20.45 4.70019V6.68019Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default MonitorIcon;

